import { of } from 'rxjs'
import { environment } from '@appEnv/environment'
import { VssUiConfigService } from '@app/classes/vss-ui-config-service'
import { VssUiConfig } from '../../../projects/vss-ui/src/vss-ui/vss-ui.model'
import { EnumSelectOptionType } from '@appModules/shares/enum/constants'
import moment from 'moment'


export class SetupVssUiConfig extends VssUiConfig {
  urlAdmin = environment.apiUrl
  contextPathBase = '/api/v1/admin'
  rangesDate = {
    Today: [moment().startOf('day').toDate(), new Date()],
    Yesterday: [moment().subtract(1, 'days').startOf('day').toDate(), moment().subtract(1, 'days').endOf('day').toDate()],
    'Last 7 Days': [moment().subtract(7, 'days').startOf('day').toDate(), new Date()],
    'Last 30 Days': [moment().subtract(3, 'days').startOf('day').toDate(), new Date()],
    'This Month': [moment().startOf('month').startOf('day').toDate(), moment().endOf('month').endOf('day').toDate()],
    'Last Month': [moment().subtract(1, 'months').startOf('day').startOf('month').toDate(), moment().subtract(1, 'months').endOf('month').endOf('day').toDate()],
  }
  decimalChar: ',' | '.' = ','
  constructor(
    private vssUiConfigService: VssUiConfigService
  ) {
    super()
    this.__initConfig()
  }

  __initConfig() {
    this.configSelectBox = {
      user: {
        optionList: [],
        apiStreamSearch: this.vssUiConfigService.getUserStream,
        getOptionsDefaultApi: this.vssUiConfigService.getDefaultUsers,
      },
      department: {
        optionList: [],
        apiGetOptions: this.vssUiConfigService.getDepartmentList,
        getOptionsDefaultApi: this.vssUiConfigService.getDefaultDepartmentList,
        isMultiLevel: true
      },
      [EnumSelectOptionType.staffRole]: {
        optionList: [],
        apiGetOptions: this.vssUiConfigService.getStaffRole,
      },
      [EnumSelectOptionType.position]: {
        optionList: [],
        apiGetOptions: this.vssUiConfigService.getPositionForSelector,
      },
      tournament: {
        optionList: [],
        apiGetOptions: this.vssUiConfigService.getTournament,
      },
      awardType: {
        optionList: [],
        apiGetOptions: this.vssUiConfigService.getAwardType,
      },
      lessonType: {
        optionList: [],
        apiGetOptions: this.vssUiConfigService.getLessonType,
      },
      classList: {
        optionList: [],
        apiGetOptions: this.vssUiConfigService.getClass,
      },
      unit: {
        optionList: [],
        apiGetOptions: this.vssUiConfigService.getUnit,
      },
      team: {
        optionList: [],
        apiGetOptions: this.vssUiConfigService.getTeam,
      },
      schoolYear: { // đang tính bỏ
        optionList: [],
        apiGetOptions: this.vssUiConfigService.getSchoolYear,
      },
      academicYear: {
        optionList: [],
        apiGetOptions: this.vssUiConfigService.getAcademicYear,
      },
      gender: {
        optionList: [],
        apiGetOptions: this.vssUiConfigService.getGender,
      },
      title: {
        optionList: [],
        apiGetOptions: this.vssUiConfigService.getTitle,
      },
      coach: {
        optionList: [],
        apiGetOptions: this.vssUiConfigService.getCoach,
        getOptionsDefaultApi: this.vssUiConfigService.getCoach,
      },
      disciplineTypeList: {
        optionList: [],
        apiGetOptions: this.vssUiConfigService.getDisciplineTypeList,
      },
      orgLocalList: { // phòng ban của mình
        optionList: [],
        apiGetOptions: this.vssUiConfigService.getOrgLocalList,
      },
      club: {
        optionList: [],
        apiGetOptions: this.vssUiConfigService.getClub,
        getOptionsDefaultApi: this.vssUiConfigService.getClub,
      },
      abbreviation: {
        optionList: [],
        apiGetOptions: this.vssUiConfigService.getPlayerPosition,
        getOptionsDefaultApi: this.vssUiConfigService.getPlayerPosition,
      },
    }
  }
}
